import { render } from "./ManagerDashboard.vue?vue&type=template&id=742ecf98&scoped=true"
import script from "./ManagerDashboard.vue?vue&type=script&lang=js"
export * from "./ManagerDashboard.vue?vue&type=script&lang=js"

import "./ManagerDashboard.vue?vue&type=style&index=0&id=742ecf98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742ecf98"]])

export default __exports__